import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ToastPrimeService } from 'src/app/shared/services/toast-prime.service';

@Component({
  selector: 'z-toaster',
  standalone: true,
  imports: [CommonModule, ToastModule],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterComponent {
  primeToast = inject(ToastPrimeService);
}
